



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { fetchAltiumPCBFootprint } from '@/api/drilldown';
import { fetchFile } from '@/api/file';
import ImagePreview from '@/components/ImagePreview.vue';
import { FetchedImages, ImageToDownload } from '@/interfaces';
import eventBus from '@/eventBus';

@Component({
  components: {
    ImagePreview,
  },
})
export default class AltiumPCBfootprint extends Vue {
  @Prop() id!: string;

  public images: FetchedImages[] = [];

  public isLoading = true;

  public fetchingImage = false;

  public canDownload = false;

  async created(): Promise<void> {
    const data = await fetchAltiumPCBFootprint(this.id);
    this.images = data.images;
    this.canDownload = data.download;
    this.isLoading = false;
  }

  public async downloadFiles(image: ImageToDownload): Promise<void> {
    this.fetchingImage = true;
    const response = await fetchFile({
      fileFolder: image.name,
      fileType: image.type,
      endpoint: 'altium-pcb-footprint',
      id: this.id,
    });
    if (!response) {
      eventBus.$emit('generalError', {
        type: 'error',
        message: this.$t('error.file').toString(),
      });
    }
    this.fetchingImage = false;
  }
}
